import { render } from "./view-counteragent-card-vers.vue?vue&type=template&id=60b68fdc"
import script from "./view-counteragent-card-vers.vue?vue&type=script&setup=true&lang=js"
export * from "./view-counteragent-card-vers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/view-counteragent-card-vers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60b68fdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60b68fdc', __exports__)) {
    api.reload('60b68fdc', __exports__)
  }
  
  module.hot.accept("./view-counteragent-card-vers.vue?vue&type=template&id=60b68fdc", () => {
    api.rerender('60b68fdc', render)
  })

}


export default __exports__